import { CommentCommon, Community, Post, Project, UserExtended } from '../swagger-api';
import { MaybeNull } from '../utils';
import { SearchState } from './search.interface';

export interface CommentView {
  source: CommentCommon;
  repliedUser?: UserExtended;
  parentCommentId: MaybeNull<string>;
}

export interface AddCommentContent {
  repliedCommentPosition: MaybeNull<CommentPosition>;
  text: string;
}

export interface AddCommentContentWithPositionParent {
  sendMessageData: AddCommentContent;
  parentCommentPosition: MaybeNull<CommentPosition>;
}

export interface RemovePostContent {
  postId: string;
  info?: Community | Project;
  state?: SearchState;
}

export interface FullRootCommentView {
  rootCommentView: CommentView;
  replyCommentViews: CommentView[];
  loadedReplyCommentsCount: number;
  totalReplyCommentsCount: number;
}

export interface LoadedCommentsState {
  rootCommentFullViews: FullRootCommentView[];
  loadedRootCommentsCount: number;
  totalRootCommentsCount: number;
}

export function makeDefaultLoadedCommentsState(): LoadedCommentsState {
  return {
    rootCommentFullViews: [],
    loadedRootCommentsCount: 0,
    totalRootCommentsCount: 0,
  };
}

export interface CommentPosition {
  indexRoot: number;
  indexReply?: number;
}

export interface SendMessageData {
  message: string;
  position: CommentPosition;
}

export interface SocialContext {
  entity_id: string;
  title: string;
}

export interface PostSocialContext {
  project_id?: SocialContext;
  community_id?: SocialContext;
}

export interface PostWithSocialContext extends Post, PostSocialContext {}
